module.exports = __webpack_public_path__ + "static/media/leave5.3c1b0576.svg";